export default __webpack_public_path__ + "static/Captain_F_400x650px-163671e1b4436cf1afd4a948f4e7e58d.png";